<ng-container [formGroup]="group">
  <h2 *ngIf="model.title">{{ model.title }}</h2>
  <div [outerHTML]="model.markup"></div>
</ng-container>
